<template>
  <div class="tabCard">
    <div class="title">
      {{ gameId==161?'选择光锥':'选择武器' }}
      <span>
        {{ gameId==161?'（请点击选择后输入光锥数量并确认）':'（请点击选择后输入武器数量并确认）' }}
      </span>
    </div>
    <div class="options">
      <div class="list">
        <div class="option" v-for="(item,index) in optionsList" :key="index" :class="{'optionSelected':checked.findIndex(val => val.id === item.id) > -1}" ref="option" >
          <div @click.stop="optionClick(item)" @dblclick.stop="dblClick(item)">{{item.name}}</div>
          <div class="secOptions weaponSelect"  v-show="item === provisionalSelection">
            <div class="label weaponSelect">
              请选择（多选）
            </div>
            <div class="secList weaponSelect">
              <div class="secOption weaponSelect" :class="{'secOptionSelected':provisionalSelection_sec.findIndex(val => val.sec_id === items.sec_id) > -1 }"
                   v-for="(items,indexs) in secOptions" :key="indexs"  @click.stop="secOptionClick(items)">
                {{items.name}}
              </div>
            </div>
            <div class="inputList weaponSelect">
              <div class="inputBox weaponSelect" v-for="(itemps,indexps) in provisionalSelection_sec" :key="indexps" >
                <div class="lebel weaponSelect">输入{{itemps.name}}数量</div>
                <el-input-number class="weaponInput weaponSelect" v-model="itemps.num" :min="1" :max="999999" :label="`输入${itemps.name}数量`" @change="(currentValue,oldValue)=>inputChange(indexps,currentValue,oldValue)" :controls="false"></el-input-number>
              </div>
            </div>
            <div class="config_btn weaponSelect" @click.stop="configClick">
              确认
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="selected">
      <div class="label">
        已选武器：
      </div>
      <div class="text">
        <span v-for="(item,index) in sortAry" :key="index">
                {{item.sec_name}}{{item.name}} x {{item.num}} {{index+1 === sortAry.length ? '':'/'}}
        </span>
      </div>
    </div>
    <div class="num">
      <div class="label">
        黄数：
      </div>
      <div class="text">
        {{ total }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "weaponTabCard",
  props:{
    gameId:{
      type:Number,
      default:26
    },
    optionsList:{
      type:Array,
      default:()=> []
    }
  },
  components:{},
  data(){
    return {
      secOptions:[
        {sec_id:'1',name:'精一'},
        {sec_id:'2',name:'精二'},
        {sec_id:'3',name:'精三'},
        {sec_id:'4',name:'精四'},
        {sec_id:'5',name:'精五'},
      ],
      total:0,
      //选中项
      checked:[],
      //临时选中
      provisionalSelection:{},
      provisionalSelection_sec:[],
      statistics:true,

      clickOut:null
    }
  },
  methods:{
    /**
     * 选项点击事件
     * @param item
     */
    optionClick(item){
      clearTimeout(this.clickOut); //清除未执行的定时器
      this.clickOut = setTimeout( ()=>{
        this.statistics = true
        this.provisionalSelection = item
        this.provisionalSelection_sec = []
        if (this.checked.findIndex(val => val.id === item.id) > -1) {
          this.provisionalSelection_sec = JSON.parse(JSON.stringify(this.checked[this.checked.findIndex(val => val.id === item.id)].secList))
        }else{
          this.secOptions[0].num = ''
          this.secOptions[0].numOld = ''
          this.provisionalSelection_sec.unshift(this.secOptions[0])
        }
      }, 200);
    },
    /**
     * 二级选项点击事件
     * @param item
     */
    secOptionClick(items){
      items.num = ''
      items.numOld = ''
      if (this.provisionalSelection_sec.findIndex(val => val.sec_id === items.sec_id) === -1 ) {
        this.provisionalSelection_sec.push(items)
      }else{
        this.provisionalSelection_sec.splice(this.provisionalSelection_sec.findIndex(val => val.sec_id === items.sec_id),1)
      }
      // console.log('secOptionClick');
    },
    /**
     * 确认按钮
     */
    configClick(){
      console.log('configClick');
      let obj = {
        id:this.provisionalSelection.id,
        name:this.provisionalSelection.name,
        sort:this.provisionalSelection.sort,
        secList:JSON.parse(JSON.stringify(this.provisionalSelection_sec))
      }
      if (this.checked.findIndex(val => val.id === obj.id) === -1 && this.provisionalSelection_sec.length > 0) {
        this.checked.push(obj)
      }else{
        if (this.checked.findIndex(val => val.id === obj.id) !== -1 && this.provisionalSelection_sec.length === 0) {
          this.checked.splice(this.checked.findIndex(val => val.id === obj.id),1)
        }else if(this.checked.findIndex(val => val.id === obj.id) !== -1){
          this.$set(this.checked,[this.checked.findIndex(val => val.id === obj.id)],obj)
          this.checked[this.checked.findIndex(val => val.id === obj.id)] = obj
        }
      }
      this.provisionalSelection = {}
      this.provisionalSelection_sec = []
      this.$emit('change',this.checked)
      let armsTotal = 0
      for (let checkedElement of this.checked) {
        checkedElement.secList.forEach(val=>{
          armsTotal = armsTotal + val.num * val.sec_id
        })
      }
      this.total = armsTotal
      this.statistics = true
    },
    inputChange(index,currentValue,oldValue){
      this.provisionalSelection_sec[index].numOld = oldValue
    },

    /**
     * 双击取消
     * @param item
     */
    dblClick(item){
      clearTimeout(this.clickOut);
      this.provisionalSelection = {}
      if (this.checked.findIndex(val => val.id === item.id) > -1) {
        this.checked.splice(this.checked.findIndex(val => val.id === item.id),1)
        this.$emit('change',this.checked)
        let armsTotal = 0
        for (let checkedElement of this.checked) {
          checkedElement.secList.forEach(val=>{
            armsTotal = armsTotal + val.num * val.sec_id
          })
        }
        this.total = armsTotal
        this.statistics = true
      }
    },

  },
  computed:{
    sortAry(){
      let arr = []
      for (let value of Object.values(this.checked)) {
        for (let item of value.secList) {
          arr.push({
            ...item,
            name:value.name,
            sec_name:item.name,
            sort: value.sort
          })
        }
      }
      return arr.sort((a, b) => {
        if (a.sec_id == b.sec_id) {
          return a.sort - b.sort
        }
        return Number(b.sec_id) - Number(a.sec_id)
      })
    }
  },
  created() {
    document.addEventListener("click", e => {
      if (e.target.className !== 'el-input__inner' && !(e.target.className.indexOf('weaponSelect') > -1)) {
        this.statistics = false
      }
    });
  },
  mounted() {

  },
  watch:{
    statistics(val){
      if (!val) {
        this.provisionalSelection_sec.forEach(item=>{
          if (item.numOld !== '') {
            item.num = item.numOld
            item.numOld = ''
          }
        })
        this.provisionalSelection = {}
        this.provisionalSelection_sec = []
      }
    }
  }
}
</script>

<style scoped lang="less">
.tabCard{
  border: 1px solid var(--border-soft, #E8E4DE);
  width: 889px;
  border-radius: 4px;
  margin: 0 0 0 120px;
  .title{
    padding: 20px 0 21px 30px;
    border-bottom: 1px solid #D7D7D7;
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #5B5B5B;
    span{
      margin: 0 0 0 2px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #5B5B5B;
    }
  }
  .options{
    border-bottom: 1px solid #D7D7D7;
    padding: 20px 0 0 34px;
    .list{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .option{
        border: 1px solid #F7F8F9;
        position: relative;
        width: 198px;
        height: 34px;
        background: #F7F8F9;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #929292;
        line-height: 34px;
        text-align: center;
        margin: 0 8px 10px 0;
        cursor: pointer;
        .secOptions{
          top: 37px;
          z-index: 999;
          position: absolute;
          width: calc(200px - 36px);
          background: #FFFFFF;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 1px solid #ECECEC;
          padding: 9px 18px 15px;
          .label{
            margin: 0 0 5px 0;
            color: #929292 !important;
          }
          .secList{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .secOption{
              width: 70px;
              height: 24px;
              background: #F7F8F9;
              border-radius: 4px 4px 4px 4px;
              margin: 4px;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #929292;
              line-height: 24px;
              text-align: center;
            }
            .secOptionSelected{
              background: var(--primary-soft, #FCEDE5);
              color: var(--primary, #FF5A1F);
            }
          }
          .inputList{
            .inputBox{
              display: flex;
              align-items: baseline;
              justify-content: space-between;
              .lebel{
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #939393;
                line-height: 24px;
              }
              .weaponInput{
                /deep/.el-input{
                  width: 78px;
                  height: 24px;
                  border-radius: 4px 4px 4px 4px;
                }
                /deep/.el-input__inner{
                  height: 24px;
                  line-height: 24px;
                  text-align: center;
                }

              }
            }
          }
          .config_btn{
            margin: 10px 0 0 ;
            width: 164px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            background: var(--primary, #FF5A1F);
            border-radius: 3px;
            font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            cursor: pointer;
            &:hover{
              background: var(--primary-hover, #E84A12);
            }
          }
        }
      }
      .option:hover{
        border: 1px solid var(--primary, #FF5A1F);
      }
      .optionSelected{
        background: var(--primary-soft, #FCEDE5);
        border: 1px solid var(--primary, #FF5A1F);
        color: var(--primary, #FF5A1F) !important;
        .list{
          .option{
            color: var(--primary, #FF5A1F) !important;
          }
        }
      }

    }
  }

  .selected,.num{
    display: flex;
    align-items: baseline;
    padding: 20px 34px;
    .label{
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      margin: 0 5px 0 0;
      flex-shrink: 0;
    }
    .text{
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #606266;
      line-height: 20px;
    }

  }
  .selected{
    border-bottom: 1px solid #D7D7D7;
  }


}

</style>
